export const ASSET_CONFIG = {
  // Base URLs for assets
  // Maps to server path: /files/public_html/apps/social-grammer-asset/audio
  AUDIO_BASE_URL: 'https://www.bkamharic.com/apps/social-grammer-asset/audio',
  // Maps to server path: /files/public_html/apps/social-grammer-asset/image
  IMAGE_BASE_URL: 'https://www.bkamharic.com/apps/social-grammer-asset/image',
  // Contact Info
  SUPPORT_EMAIL: 'support@bkamharic.com'
};

// Helper function to generate audio URLs
// Example: getAudioUrl('beteseb') -> https://www.bkamharic.com/apps/social-grammer-asset/audio/beteseb.mp3
export const getAudioUrl = (id) => {
  if (!id) return '';
  // If id already has extension, don't add it again (basic check)
  const cleanId = id.endsWith('.mp3') ? id.slice(0, -4) : id;
  return `${ASSET_CONFIG.AUDIO_BASE_URL}/${cleanId}.mp3`;
};

export const getImageUrl = (filename) => `${ASSET_CONFIG.IMAGE_BASE_URL}/${filename}`;